import { S3_BUCKET_NAME } from "../BaseUrl";

const ADMIN_ALWAYS = 'dep@gmail.com';
// const BUCKET_NAME = process.env.REACT_APP_ENVIRONMENT === 'develop' ? 'dep-develop' : 'dep-qa';

const BUCKET_NAME = `${S3_BUCKET_NAME}`;
const PROCESSED_BUCKET = process.env.REACT_APP_ENVIRONMENT === 'develop' ? 'cdep-landing-zone' : 'qa-landingzone';

const SALES_EMAIL = 'testing@gmail.com';
const SALES_PASSWORD = 'testing123';
const SALES_DOMAIN_TYPE = 'sales';

export const DATA_TYPE_READ = "reference";

const CUSTOMER_EMAIL = 'test22@gmail.com';
const CUSTOMER_PASSWORD = 'test@12322';
const CUSTOMER_DOMAIN_TYPE = 'customers';

export {
  ADMIN_ALWAYS,
  BUCKET_NAME, CUSTOMER_DOMAIN_TYPE,
  CUSTOMER_EMAIL,
  CUSTOMER_PASSWORD,
  PROCESSED_BUCKET, SALES_DOMAIN_TYPE, SALES_EMAIL,
  SALES_PASSWORD
};

export const COLUMN_TRANSFORMATIONS = [
  'abs', 'concat', 'current_date', 'concat_ws', 'coalesce', 'floor',
  'upper', 'trim', 'current_time', 'lower', 'isspaces', 'isnull',
  'instr', 'length', 'isnumber', 'initcap', 'indexof', 'lpad' , 'ltrim', 'rpad', 'substr',
  'replace', 'split', 'regexp_replace', 'round', 'regexp_instr', 'to_integer', 'to_decimal', 'to_float',
  'to_integer', 'to_bigint', 'row_number', 'mod', 'power', 'reverse', 'nullif', 'to_date', 'date_diff',
  'add_to_date', 'last_day', 'nullif', 'regexp_substr', 'trunc_dates', 'rtrim', 'add_static_value',
  'date_compare' , 'to_char_numbers' , 'is_date' , 'to_char', 'ceil', 'trunc_numbers' , 'reg_extract',
  'reg_match', 'round_numbers'
]